import React, { Component } from 'react';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';
import Asset from './Asset';

import { AssetProps } from './Helpers';

import UniversalLinkContainer from './UniversalLink';

export default class OurApproach extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openToggle: props.expanded,
    };
  }

  render() {
    const {
      subHeader,
      links,
      anchor,
      toggleAccordion,
      header,
      images,
      copy,
    } = this.props;
    const splitSubHeader = subHeader && subHeader.split('\n');
    const moreLink = links && links[0];

    return (
      <section
        id={anchor || undefined}
        className="pdp-btf-section our-approach"
      >
        <a className="anchor" />
        <div
          className={classNames('pdp-btf-section-title', { active: this.state.openToggle })}
          onClick={toggleAccordion?.bind(this)}
        >
          <h2>{header}</h2>
          <div className="icon-container">
            <i className={classNames('icon', 'icon-nav-arrow', { active: this.state.openToggle })}/>
          </div>
        </div>
        <div className={classNames('pdp-btf-section-wrapper', { active: this.state.openToggle })}>
          {images && images.length > 0
            && (
              <div className="our-approach-image">
                <LazyLoad offset={0} placeholder={<div className="image-placeholder" />}>
                  <Asset
                    asset={images[0]}
                    imageClassName="image"
                  />
                </LazyLoad>
              </div>
            )
          }
          <div className="our-approach-person">
            <p className="name">{splitSubHeader[0]}</p>
            <p className="position">{splitSubHeader[1]}</p>
          </div>
          <h3 className="our-approach-quote-mark">“</h3>
          <h3 className="our-approach-quote">{copy}”</h3>
          <div className="our-approach-learn-more">
            {moreLink && (
              <UniversalLinkContainer
                {...moreLink}
                className={moreLink.className || `link ${moreLink.textColor && moreLink.textColor.toLowerCase()}`}
                to={moreLink.destinationPage.url}
                location="ourapproach"
              >
                {moreLink.text}
              </UniversalLinkContainer>
            )}
          </div>
        </div>
      </section>
    );
  }
}

OurApproach.propTypes = {
  images: PropTypes.arrayOf(AssetProps),
  color: PropTypes.string,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  anchor: PropTypes.string,
  copy: PropTypes.string,
  toggleAccordion: PropTypes.func,
};
